import React from "react";
import { Link } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

// import error500 from "../../assets/other/500_error.png"; // ✅ Add your server error image
import error404 from "../../assets/other/404_error.png";

const Error500 = () => {
  return (
      <div
  className="error-page"
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // full viewport height
    textAlign: "center",
    flexDirection: "column",
  }}
>
    <div className="error-content" style={{ margin: "40px 25px", textAlign: "center" }}>
  <div className="error-text">
    {/* <h1 style={{ fontSize: "72px", marginBottom: "10px", color: "var(--primary-color)" }}>
      500
    </h1>
    <h2>Internal Server Error</h2>
    <p>
      Oops! Something went wrong on our end. <br />
      Please try again later or return to the home page.
    </p> */}


{/* <h1 style={{ fontSize: "72px", marginBottom: "10px", color: "var(--primary-color)" }}>
     
    </h1> */}
    <h2> Something Went Wrong</h2>
    <p>
      The page didn’t load correctly this time. <br/>
We’re already looking into it. <br/>
Please try again in a few moments or return to the Home Page. <br/>

    </p>

    <Link className="error-btn-link" to={"/"}>
      <button
        type="button"
        className="error-btn"
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          borderRadius: "6px",
          background: "var(--primary-color)",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <IoArrowBack />
        Back to Home
      </button>
    </Link>
  </div>
</div>

</div>

  );
};

export default Error500;


// import React from "react";
// import { Link } from "react-router-dom";
// import { IoArrowBack } from "react-icons/io5";
// // import { Container, Row, Col } from "react-bootstrap";
// // import { Link } from "react-router-dom";

// // img
// // import error500Light from "../../../assets/images/error/505-light.png";
// // import error505 from "../../../assets/images/error/505.png";

// const Error500 = () => {
//   return (
//     <>
//       <div className="error-page">
//         <div className="error-content">
//           {/* <img src={error505} className="error-img img-light" alt="error-img" /> */}
//           <div className="error-text">
//             <h2>Oops! This Page is Not Found.</h2>
//             <p>The requested page does not exist.</p>
//             <Link className="error-btn-link" to={"/"}>
//               <button type="button" className="error-btn">
//                 <IoArrowBack />
//                 Back to Home
//               </button>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Error500;
